import { Component } from '@angular/core';
import { BaseInputFieldComponent } from '../base/base-input-field.component';

@Component({
  selector: 'shared-ui-inputs-checkbox-field',
  templateUrl: './checkbox-field.component.html',
  styleUrls: ['./checkbox-field.component.css'],
  standalone: false,
})
export class CheckboxFieldComponent extends BaseInputFieldComponent {
  randomId: string;

  constructor() {
    super();

    this.randomId = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, '')
      .substring(2, 10);
  }
}
